import { render, staticRenderFns } from "./dispatchRepair.vue?vue&type=template&id=5465ef4e&scoped=true"
import script from "./dispatchRepair.vue?vue&type=script&lang=js"
export * from "./dispatchRepair.vue?vue&type=script&lang=js"
import style0 from "./dispatchRepair.vue?vue&type=style&index=0&id=5465ef4e&prod&scoped=true&lang=css"
import style1 from "./dispatchRepair.vue?vue&type=style&index=1&id=5465ef4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465ef4e",
  null
  
)

export default component.exports